import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/pro-thin-svg-icons';
import { Typography } from '@mui/material';
import { FontIcon } from '@resurs-internal/mui';
import { ReactNode, useState } from 'react';

import { FlexStyles, SummaryStyles } from './Summary.styles';

type Props = {
    label: string;
    children: ReactNode;
    expand?: boolean;
};

const Summary = ({ label, children, expand }: Props) => {
    const [expanded, setExpanded] = useState(expand ? false : true);

    return (
        <SummaryStyles>
            <FlexStyles expanded={expanded} onClick={() => setExpanded(!expanded)}>
                <Typography variant={'subtitle1'}>{label}</Typography>
                <button aria-label={expanded ? `close ${label}` : `open ${label}`}>
                    <FontIcon
                        icon={expanded ? (faChevronUp as IconDefinition) : (faChevronDown as IconDefinition)}
                        size="xs"
                        cursor={'pointer'}
                    />
                </button>
            </FlexStyles>
            {expanded ? children : null}
        </SummaryStyles>
    );
};

export default Summary;
